import { Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { Add as AddIcon } from "@material-ui/icons";
import React from "react";
import styled from "styled-components";
import { Paper } from "../../../common/components/libs";
import { observer } from "mobx-react";
import { useHistory } from "react-router-dom";


const Wrapper = styled(Paper)`
  padding: ${
    props => {
        return props.theme.spacing(6)
    }}px;

  ${props => props.theme.breakpoints.up("md")} {
    padding: ${props => props.theme.spacing(10)}px;
  }
`;


const NoPaymentData = (props) => {

    const history = useHistory();

    return <div style={{ maxWidth: 500 }}>
        <Wrapper>
            <Typography component="h1" variant="h4" align="center" gutterBottom>
                Создайте вашу анкету!
            </Typography>
            <Typography component="h4" variant="body2" align="center" gutterBottom>
                В анкете хранятся все платежные реквизиты, необходимые для сотрудничества.
            </Typography>
            <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
                <Button 
                    onClick = {() => history.push("/documents/application-form")}
                    variant="contained"
                    color="primary"
                >
                    <AddIcon/>
                    Добавить
                </Button>
            </div>

        </Wrapper>
    </div>
};


export default observer(NoPaymentData)
